import type { IApiUpdatePatient } from '@app/state/patients/helpers'

import type { IContact } from '../contact/contact.interface'
import type { INamedPerson } from '../person/person.interface'
import type { IProgramId, IProgramEnrolment } from '../program/program.interface'

export type IPersonAge = number
export type IPatientDateOfBirth = string
export type IPatientGeneralPractitioner = string
export type IPatientMedicalRecordNumber = string
export type IPatientId = string
export type IPatientUpdatedAt = string
export type IPatientEmailAddress = string
export type IPatientPhoneNumber = string

export enum PatientBirthSexId {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other',
  Unknown = 'Unknown',
}

export type IGetPatientOptions = {
  birthSex?: string[]
  dateOfBirth?: string
  inProgramId?: IProgramId
  mrn?: string
  notInProgramId?: IProgramId
  patientName?: string
  sortDirection?: string
  sortField?: string
}

export enum ProgramStartOption {
  Now = 'Now',
  Custom = 'Custom',
}

export enum PhoneNumberTypeId {
  null = '',
  Mobile = 'mobile',
  Landline = 'landline',
}

export type IPatientContactInformation =
  | {
      emailAddress: IPatientEmailAddress
      phoneNumber: IPatientPhoneNumber
      phoneNumberType: PhoneNumberTypeId
    }
  | {
      emailAddress: string
    }
  | {
      phoneNumber: string
      phoneNumberType: PhoneNumberTypeId
    }

export interface IPatientCommunicationConsent {
  consentsToSms: boolean
  consentsToEmail: boolean
}

export interface IPatient extends INamedPerson {
  age?: IPersonAge
  birthSex?: PatientBirthSexId
  contact?: IContact[]
  dateOfBirth?: IPatientDateOfBirth
  generalPractitioner?: IPatientGeneralPractitioner
  medicalRecordNumber: IPatientMedicalRecordNumber
  id: IPatientId
  updatedAt: IPatientUpdatedAt
  contactInformation?: IPatientContactInformation
}

export type IUseGetPatientStatus = 'idle' | 'loading' | 'error' | 'success'
export interface IUseGetPatient {
  patient: IPatient
  getPatient: (patientId: string) => void
  status: IUseGetPatientStatus
}

export interface IUseProgramEnrolments {
  patientProgramEnrolments: IProgramEnrolment[]
  getPatientProgramEnrolments: (patientId: string) => void
  sendInteractionToIntakeAnywhere: (
    patientId: string,
    programInteractionId: string,
  ) => void
  revokeInteraction: (patientId: string, programInteractionId: string) => void
}

export interface IUsePatientSearch {
  patients: IPatient[]
  pageCount: number
  totalNumberOfRecords: number
  isLoading: boolean
  getPatients: (
    pageNumber: number,
    recordsPerPage: number,
    options: IGetPatientOptions,
  ) => void
}

export interface IUsePatient {
  patient: IPatient
  getPatient: () => void
  updatePatient: (patient: IApiUpdatePatient) => void
}
